module.exports = __webpack_public_path__ + "static/header-image-06-bd01f965a4a4574cb9949ba9bba5884d.png";